import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { loginAuthAPI } from "@/auth/api/loginAuthAPI";
import { AuthContext } from "@/auth/context";
import { Types } from "@/auth/types";
import { clearAuthData } from "@/lib/tokenRefresh";
import { paths } from "@/routes/paths";

/**
 * Hook for handling user logout
 * Clears all authentication data and redirects to login page
 */
export const useLogout = () => {
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  return useCallback(async () => {
    try {
      const response = await loginAuthAPI.logout();
      toast.success(
        response.detail || "You have been logged out successfully.",
      );
    } catch {
      toast.error("Logout request failed. Signed out locally.");
    } finally {
      clearAuthData();
      dispatch({
        type: Types.LOGOUT,
      });
      navigate(paths.auth.login, { replace: true });
    }
  }, [dispatch, navigate]);
};
